import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";
import { SOURCES } from "./../Utils";
import CardSetView from "./CardSetView";
import { useParams } from "react-router-dom";
var dateFormat = require("dateformat");

const FILTER_SOURCES = SOURCES.sort().map((source) => {
  return { value: source, label: source };
});

export default ({ userCache }) => {
  const [card, setCard] = useState(null);
  const [user, setUser] = useState(null);
  const [notFound, setNotFound] = useState(false);

  let { id } = useParams();

  useEffect(() => {
    adminRecords.collection("cards")
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setCard(doc);
          userCache.fetchIds([doc.get("userId")]).then(() => {
            setUser(userCache.getUser(doc.get("userId")));
          });
        } else {
          setNotFound(true);
        }
      });
  }, []);

  return (
    <div id="card-set-get">
      <div className="inner">
        {notFound && <h2>Card Set not found</h2>}
        {card && !notFound && (
          <CardSetView
            data={card}
            user={user}
          />
        )}
      </div>
    </div>
  );
};
